import styled from 'styled-components'
import { cardisTheme } from '../../theme/cardisTheme'

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xsmall};
`

export const FieldLabel = styled.label`
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  color: ${cardisTheme.colors.primary};
`

export const EditableDiv = styled.div<{
  $multiline?: boolean
  $hasValue?: boolean
}>`
  min-height: ${({ $multiline }) => ($multiline ? '48px' : '20px')};
  padding: ${({ theme }) => theme.spacing.xsmall}
    ${({ theme }) => theme.spacing.small};
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  font-weight: ${({ theme }) => theme.typography.fontWeight.normal};
  color: ${({ theme }) => theme.colors.text.primary};
  line-height: 1.5;
  white-space: ${({ $multiline }) => ($multiline ? 'pre-wrap' : 'nowrap')};
  overflow: ${({ $multiline }) => ($multiline ? 'auto' : 'hidden')};
  text-overflow: ellipsis;
  transition: all ${({ theme }) => theme.transitions.fast};

  /* Screen styles - show editing indicators */
  @media screen {
    /* Empty fields - highlight with amber background to draw attention */
    outline: ${({ $hasValue }) =>
      $hasValue ? '1px solid #E0E0E0' : '1px dashed #FFD54F'};
    background: ${({ $hasValue }) => ($hasValue ? 'transparent' : '#FFF8E1')};
    border-radius: ${({ theme }) => theme.borderRadius.small};
    cursor: text;

    &:hover {
      outline: ${({ $hasValue }) =>
        $hasValue ? '1px solid #BDBDBD' : '2px solid #FFD54F'};
      background: ${({ $hasValue }) => ($hasValue ? '#F5F5F5' : '#FFF3CD')};
    }

    &:focus {
      outline: 2px solid
        ${({ $hasValue }) =>
          $hasValue ? cardisTheme.colors.primary : '#FFB300'};
      background: ${({ $hasValue }) => ($hasValue ? '#F5F5F5' : '#FFF3CD')};
      box-shadow: 0 0 0 3px
        ${({ $hasValue }) =>
          $hasValue ? 'rgba(0, 64, 128, 0.1)' : 'rgba(255, 179, 0, 0.15)'};
    }

    &:empty::before {
      content: attr(data-placeholder);
      color: ${({ theme }) => theme.colors.text.tertiary};
      font-style: italic;
    }
  }

  /* Print styles - hide editing indicators */
  @media print {
    outline: none !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    padding: 0;

    &:empty::before {
      content: '';
    }
  }
`
